const t = "完成したステップ", o = "{buttonName}に戻る", e = "{buttonName} に移動", n = {
  completedStep: t,
  backButton: o,
  nextButton: e
};
export {
  o as backButton,
  t as completedStep,
  n as default,
  e as nextButton
};
